import React from 'react';
import letsTalkImage from '../assets/images/letstalk.png';
import dropdownIcon from '../assets/images/frame.svg';
import submitIcon from '../assets/images/btn-icon-5.svg';
import '../assets/styles/RequestCallback.css';

const RequestCallback = () => {
  return (
    <section className="py-5 request-callback-section">
      <div className="container">
        <div className="request-callback-wrapper">
          <div className="row align-items-center g-5">
          {/* Image Section */}
          <div className="col-lg-6 text-center">
            <img src={letsTalkImage} alt="Let's Talk" className="img-fluid rounded w-100" style={{ maxHeight: '794px', objectFit: 'cover' }} />
          </div>

          {/* Form Section */}
          <div className="col-lg-6">
            <h2 className="fw-bold display-6 mb-3">Need Home Maintenance? Let's Talk!</h2>
            <p className="text-muted mb-4">
              Do id occaecat eiusmod enim voluptate do Lorem magna eiusmod quis velit labore nulla incididunt ex.
            </p>

            <form className="d-flex flex-column gap-3">
              {/* Name Field */}
              <div>
                <label className="form-label fw-medium">Name</label>
                <input type="text" className="form-control rounded-3 p-3" placeholder="Enter your name here" />
              </div>

              {/* Phone Number Field */}
              <div>
                <label className="form-label fw-medium">Phone Number</label>
                <input type="tel" className="form-control rounded-3 p-3" placeholder="+91 XXXXX XXXXX" />
              </div>

              {/* Property Location Dropdown (static for now) */}
              <div>
                <label className="form-label fw-medium">Property Location</label>
                <div className="position-relative">
                  <input type="text" className="form-control rounded-3 p-3 pe-5" placeholder="Kochi" readOnly />
                  <img
                    src={dropdownIcon}
                    alt="Dropdown"
                    className="position-absolute end-0 top-50 translate-middle-y me-3"
                    style={{ width: '20px', height: '20px' }}
                  />
                </div>
              </div>

              {/* Additional Notes Field */}
              <div>
                <label className="form-label fw-medium">Additional Notes (Optional)</label>
                <textarea className="form-control rounded-3 p-3" rows="4" placeholder="Enter additional notes here" />
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn btn-success submit-request-btn d-flex align-items-center justify-content-center gap-2 px-4 py-3 rounded-pill mt-2">
                <span>Submit Request</span>
                <img src={submitIcon} alt="Submit" width="20" height="20" />
              </button>
            </form>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default RequestCallback;